<template>
  <detail-card v-if="voucher"
               type="voucher"
               :data="voucher"
               v-bind="$attrs">
    <template v-slot:header>{{ voucher.code }}</template>
    <template v-slot:body>
      <prop name="Typ">{{ voucher.type }}</prop>
      <prop v-if="voucher.type === 'Value'" name="Wert">{{ voucher.valueOrPercentage |price }}</prop>
      <div v-if="voucher.type === 'Product'">
        <prop name="Produkt" type="product">{{ voucher.product.name }}</prop>
        <prop name="Teilnehmer" type="customer">{{ voucher.attendees }}</prop>
      </div>
      <div v-if="voucher.type === 'Special'">
        <prop name="Spezial-Logik">{{ voucher.logic }}</prop>
      </div>
      <prop name="gültig bis">{{ voucher.validUntilDate | date }}</prop>
      <prop name="letztes Erlebnis am">
        <span v-if="!editLatestEventDate">
          {{ voucher.latestEventDate | date }}
          <button class="btn btn-sm btn-primary ml-2" @click="startEditLatestEventDate">Ändern</button>
        </span>
        <span v-else>
          <input type="date" v-model="latestEventDate"/>
          <button class="btn btn-sm btn-primary ml-2" @click="saveLatestEventDate">Speichern</button>
          <button class="btn btn-sm btn-secondary ml-1" @click="editLatestEventDate = false">Abbrechen</button>
        </span>
      </prop>
      <prop name="aktiv">
        <bool :value="voucher.activated"/>
        <button class="btn btn-sm btn-primary ml-2" @click="toggleActivated">
          {{ voucher.activated ? 'Deaktivieren' : 'Aktivieren' }}
        </button>
      </prop>
      <prop name="eingelöst">
        <bool :value="voucher.redeemed"/>
      </prop>
      <prop v-if="voucher.redeemed" name="genutzter Wert">{{ voucher.valueApplied | price }}</prop>
      <ref v-if="voucher.redeemed"
           :id="voucher.usedIn.id"
           type="order"
           name="benutzt in">{{ voucher.usedIn.number }}
      </ref>
    </template>
  </detail-card>
</template>
<script>
import DetailCard from "@/layouts/DetailCard";
import Prop from "@/layouts/Prop";
import Ref from '@/layouts/Ref'
import Bool from "@/layouts/Bool";

export default {
  props: {
    voucher: Object
  },
  components: {Bool, DetailCard, Prop, Ref},
  data() {
    return {
      editLatestEventDate: false,
      latestEventDate: null
    }
  },
  methods: {
    startEditLatestEventDate() {
      this.latestEventDate = this.voucher.latestEventDate
      this.editLatestEventDate = true
    },
    saveLatestEventDate() {
      // ohne Datum setzt das Backend den Standard (Verfallsdatum + 12 Monate)
      this.$api.put(`/vouchers/${this.voucher.code}/latest-event-date`, {}, {params: {date: this.latestEventDate || undefined}})
          .then(() => this.$router.go())
          .catch(err => this.handleError(err))
    },
    toggleActivated() {
      this.$api.put(`/vouchers/${this.voucher.code}`, {}, {params: {activated: !this.voucher.activated}})
          .then(() => this.$router.go())
          .catch(err => this.handleError(err))
    }
  }
}
</script>
